import { render, staticRenderFns } from "./Introduction.vue?vue&type=template&id=e07a2b36&scoped=true"
import script from "./Introduction.vue?vue&type=script&lang=js"
export * from "./Introduction.vue?vue&type=script&lang=js"
import style0 from "./Introduction.vue?vue&type=style&index=0&id=e07a2b36&prod&scoped=true&lang=css"
import style1 from "./Introduction.vue?vue&type=style&index=1&id=e07a2b36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_bddh7bz47tm4asog4nvkp26dru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e07a2b36",
  null
  
)

export default component.exports